

import { Component, Mixins } from "vue-property-decorator";
import IBAlertFixed from "@/components/IBAlert/IBAlertFixed/IBAlertFixed.vue";
import AppVersionErrorMessage from "@/feature/AppVersion/mixins/AppVersionErrorMessage";
import IBModal from "@/components/Modal/IBModal.vue";
import IBDialogContainer from "@/components/IBDialog/IBDialogContainer.vue";
import IBDialog from "@/components/Dialog/IBDialog.vue";

@Component({
	components: {
		IBDialog,
		IBDialogContainer,
		IBModal,
		IBAlertFixed,
	}
})
export default class IBAlertContainer extends Mixins(
	AppVersionErrorMessage
) {

	isOperValidBrowser: boolean = false;

	openModalBrowserList() {
		this.isOperValidBrowser = !this.isOperValidBrowser;
	}

}
